define('app/helpers/filter-helpers',[],function() {
  return {
    matchFilter: matchFilter,
    filterByActiveFilter: filterByActiveFilter,
  };

  // Match tag to the filter
  function matchFilter(object) {
    if (!object.tags) return true; // Objects with no tags match all filters

    return object.tags.split(',').some(function(t) {
      return this.filter.split(',').some(function(f) {
        return f.trim() === t.trim();
      });
    }, this);
  }

  // Filter out geoobjects that is not on the active filter
  function filterByActiveFilter(objects, activeFilter) {
    if (!activeFilter) return objects;

    return objects.filter(function(x) {
      return activeFilter.matches(x);
    });
  }
});

